import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "-4 -3 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.6569 2.3038C16.781 5.37554 16.781 10.3558 13.6569 13.4276L9.7179 17.3004C8.76913 18.2332 7.23087 18.2332 6.2821 17.3004L2.34314 13.4276C-0.781049 10.3558 -0.781048 5.37554 2.34315 2.3038C5.46734 -0.767935 10.5327 -0.767935 13.6569 2.3038ZM8.00021 10.387C9.5733 10.387 10.8485 9.13321 10.8485 7.58653C10.8485 6.03985 9.5733 4.78602 8.00021 4.78602C6.42712 4.78602 5.15188 6.03985 5.15188 7.58653C5.15188 9.13321 6.42712 10.387 8.00021 10.387Z"
    }, null, -1)
  ])))
}
export default { render: render }